// Calendrier scolaire officiel — académie de Martinique (miroir de backend/utils/martinique_calendar.py)
export const SCHOOL_HOLIDAYS = [
    ['2020-10-24', '2020-11-08', 'Toussaint'],
    ['2020-12-19', '2021-01-03', 'Noël'],
    ['2021-02-06', '2021-02-21', 'Carnaval'],
    ['2021-03-27', '2021-04-11', 'Pâques'],
    ['2021-07-06', '2021-09-12', 'Été'],
    ['2021-10-23', '2021-11-07', 'Toussaint'],
    ['2021-12-18', '2022-01-02', 'Noël'],
    ['2022-02-23', '2022-03-06', 'Carnaval'],
    ['2022-04-09', '2022-04-20', 'Pâques'],
    ['2022-07-08', '2022-08-31', 'Été'],
    ['2022-10-22', '2022-11-06', 'Toussaint'],
    ['2022-12-17', '2023-01-02', 'Noël'],
    ['2023-02-11', '2023-02-26', 'Carnaval'],
    ['2023-04-01', '2023-04-16', 'Pâques'],
    ['2023-07-08', '2023-09-03', 'Été'],
    ['2023-10-21', '2023-11-05', 'Toussaint'],
    ['2023-12-23', '2024-01-07', 'Noël'],
    ['2024-02-10', '2024-02-25', 'Carnaval'],
    ['2024-03-23', '2024-04-07', 'Pâques'],
    ['2024-07-06', '2024-09-01', 'Été'],
    ['2024-10-19', '2024-11-03', 'Toussaint'],
    ['2024-12-21', '2025-01-05', 'Noël'],
    ['2025-02-22', '2025-03-09', 'Carnaval'],
    ['2025-04-12', '2025-04-27', 'Pâques'],
    ['2025-07-05', '2025-08-31', 'Été'],
    ['2025-10-18', '2025-11-02', 'Toussaint'],
    ['2025-12-20', '2026-01-04', 'Noël'],
    ['2026-02-07', '2026-02-22', 'Carnaval'],
    ['2026-03-28', '2026-04-19', 'Pâques'],
    ['2026-07-04', '2026-08-31', 'Été'],
    ['2026-10-20', '2026-11-02', 'Toussaint'],
    ['2026-12-19', '2027-01-03', 'Noël'],
    ['2027-02-06', '2027-02-21', 'Carnaval'],
    ['2027-03-24', '2027-04-01', 'Pâques'],
    ['2027-04-20', '2027-05-02', 'Pâques'],
    ['2027-07-03', '2027-08-31', 'Été'],
];

// Fenêtres de vacances recoupant une liste de dates ISO triées (pour ombrage graphique)
export function holidayAreas(dates) {
    if (!dates?.length) return [];
    const first = dates[0], last = dates[dates.length - 1];
    const set = new Set(dates);
    const clamp = (iso, dir) => {
        // trouve la date de la série la plus proche à l'intérieur de la fenêtre
        let d = iso;
        for (let i = 0; i < 40 && !set.has(d); i++) {
            const dt = new Date(d + 'T12:00:00');
            dt.setDate(dt.getDate() + dir);
            d = dt.toISOString().slice(0, 10);
        }
        return set.has(d) ? d : null;
    };
    const areas = [];
    for (const [start, end, label] of SCHOOL_HOLIDAYS) {
        if (end < first || start > last) continue;
        const x1 = clamp(start < first ? first : start, 1);
        const x2 = clamp(end > last ? last : end, -1);
        if (x1 && x2 && x1 <= x2) areas.push({ x1, x2, label });
    }
    return areas;
}
